"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var forms_1 = require("@rebass/forms");
var tema_1 = require("../../tema");
var classnames_1 = __importDefault(require("classnames"));
var VariacaoDoInput;
(function (VariacaoDoInput) {
  VariacaoDoInput["quadrado"] = "quadrado";
})(VariacaoDoInput || (VariacaoDoInput = {}));
exports.default = function (_a) {
  var _b;
  var desabilitado = _a.desabilitado,
    _c = _a.selecionado,
    selecionado = _c === void 0 ? false : _c,
    variant = _a.variant,
    onChange = _a.onChange,
    children = _a.children,
    outrasPropriedadesDoInput = __rest(_a, ["desabilitado", "selecionado", "variant", "onChange", "children"]);
  var handleOnChange = function () {
    if (desabilitado) return;
    !!onChange && onChange();
  };
  return react_1.default.createElement(tema_1.Tema, null, react_1.default.createElement(forms_1.Label, __assign({
    className: classnames_1.default((_b = {
      selecionado: selecionado
    }, _b[variant] = true, _b)),
    sx: __assign({
      position: 'relative',
      display: 'flex',
      alignItems: 'flex-start',
      color: selecionado && !desabilitado ? 'blue2' : 'blue4',
      cursor: 'pointer',
      fontSize: [1, 2],
      lineHeight: 1.15,
      '& > input': {
        position: 'relative',
        m: 0,
        minHeight: '1rem',
        minWidth: '1rem',
        borderRadius: 50,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: selecionado && !desabilitado ? 'blue2' : 'blue4',
        cursor: 'pointer',
        appearance: 'none',
        mr: 2,
        mt: '1px',
        outline: 'none',
        '&:disabled': {
          opacity: 0.4
        },
        ':after': {
          display: selecionado ? 'block' : 'none',
          content: '""',
          boxSizing: 'border-box',
          position: 'absolute',
          p: '5px',
          borderRadius: 50,
          top: '2px',
          left: '2px',
          backgroundColor: 'blue2'
        }
      },
      '&.quadrado': {
        '& > input': {
          padding: '0.43785rem',
          borderRadius: '5px',
          '&:checked': {
            backgroundColor: 'blue2'
          },
          ':after': {
            display: selecionado ? 'block' : 'none',
            content: '""',
            boxSizing: 'border-box',
            position: 'absolute',
            top: '1px',
            left: '5px',
            height: '10px',
            width: '5px',
            borderWidth: '0 2px 2px 0',
            borderStyle: 'solid',
            borderColor: 'white',
            transform: 'rotate(45deg)',
            p: 'unset',
            borderRadius: 'unset'
          }
        }
      }
    }, outrasPropriedadesDoInput === null || outrasPropriedadesDoInput === void 0 ? void 0 : outrasPropriedadesDoInput.sx)
  }, outrasPropriedadesDoInput), react_1.default.createElement("input", {
    type: "radio",
    onChange: handleOnChange,
    checked: selecionado,
    disabled: desabilitado
  }), children));
};